module.exports = __webpack_public_path__ + "img/menu.5e98ad33.svg";